// This is the home page of the Windsor Lending site. 
// Author: Rivka Markowitz
// Last updated: Feb 2025

/* Purpose: This is the home page for signed in users
 * Props: GlobalVar (map)
          isAdmin (boolean)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import {React, useEffect} from "react";
import SloganHeader from "../Components/SloganHeader";
import HomeInfo from "../Components/HomeInfo";
import { Link } from "react-router-dom";
import { Button} from "react-bootstrap";


const Home = ({GlobalVar, isAdmin, isGeust}) => {
    // Remove the auth code if there is one attached as querystring params
    useEffect(() => {
        const currentLocation = window.location.href;

        if (currentLocation.includes("?code=")){
           window.location.href = GlobalVar.HOME_URL;  
        }

        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
       
    }, [])

    return (
        <div className="align-items-center text-center">
            <SloganHeader page = "Home"/>
            <div className="align-items-center text-center">
                {isAdmin?(
                    <Link className="home-link" to="/Admin"><Button className = "home-page-btn" variant = "secondary">Go To Client List</Button></Link>

                ):(
                    <Link className="home-link" to="/Portal"><Button className = "home-page-btn" variant = "secondary">Go To Portal</Button></Link>
                )}
            </div>
            <HomeInfo />
        </div>
    );
}

export default Home;
